
///客户端是pc端还是移动端
export function isPC(){  
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|huawei|Android|oppo|vivo|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return !flag
}
//自动滚动到对应的错误项
export function elFormErrorScrollIntoView() { 
  // 获取第一个校验错误的元素 
  const element = document.querySelectorAll('.el-form-item.is-error')[0] 
  // 滚动到错误元素对应位置 
  element.scrollIntoView({ 
    behavior: 'smooth', 
    block: 'center' 
  }) 
}
//打开文件链接
export function openFile(url) {
  if (url) {
    window.open(url, '_blank')
  }
}
//获取文件后缀
export function getFileSuffix(url) {
  let fileSuffix = ''
  if (url) {
    const index = url.lastIndexOf('.')
    fileSuffix = url.substring(index + 1)
  }
  return fileSuffix
}
//获取文件名
export function getFileName(url) {
  let fileName = ''
  if (url) {
    const index = url.lastIndexOf('/')
    fileName = url.substring(index + 1)
  }
  return fileName
}
//a标签下载文件
export function downloadFile(url, fileName) {
  var eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  eleLink.href = url
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}
//一维数组根据对象值转二维数组
export function arrayToTwoDimensional(arr, key) {
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    let item = arr[i];
    let obj = {};
    obj[key] = item;
    newArr.push(obj);
  }
  return newArr;
}
///数字小数点
export function toFixed(number, m) {
    if (typeof number !== "number") {
      throw new Error("number不是数字");
    }
    let result = Math.round(Math.pow(10, m) * number) / Math.pow(10, m);
    result = String(result);
    if (result.indexOf(".") == -1) {
      if (m != 0) {
        result += ".";
        result += new Array(m + 1).join("0");
      }
    } else {
      let arr = result.split(".");
      if (arr[1].length < m) {
        arr[1] += new Array(m - arr[1].length + 1).join("0");
      }
      result = arr.join(".");
    }
    return result;
}
export function integralComputation(point, pet){
    return  Math.round(point / pet) 
}
export function  Mathround(value){
    return  parseInt(value) 
}
///判断输入值是否为正整数
export function isPositiveInteger(s){
  if((/(^[1-9]\d*$)/.test(s))) {
     return  true
  } else {
    return false
  }
}    
///转换为了大写字符
export function stringToUpperCase(value){
   return value.toUpperCase()
}